import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { SKIP_AUTH0 } from '../tokens/http-context.tokens';

import { IZA_CONFIG } from '../iza-config';

export const autosyncInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(IZA_CONFIG);
  const isIzaUrl = req.url.startsWith(config.ahriApiUrl) || req.url.startsWith(config.autosync.apiUrl);

  if (isIzaUrl && req.context.get(SKIP_AUTH0)) {
    const cloneReq = req.clone({
      setHeaders: {
        'x-api-key': config.autosync.token,
      },
    });
    return next(cloneReq);
  }

  return next(req);
};
